
const HasPublishedTranslations = {
  "name": "HasPublishedTranslations",
  "kind": "INTERFACE",
  "fieldBaseTypes": {
    "translations": "PublishedTranslation"
  },
  "possibleTypes": ["Collection", "Link", "OnlineStoreArticle", "OnlineStoreBlog", "OnlineStorePage", "Product", "ProductOption", "ProductVariant", "Shop", "ShopPolicy"]
};
export default HasPublishedTranslations;